import React from 'react';
import "../css/sidemenu.css"
import SideItem from './sideitem';
import WarehouseOutlinedIcon from '@mui/icons-material/WarehouseOutlined';
import { visibleMenuGroups } from './menuitems';


// `icononly` is true when the menu is expanded (name kept for compatibility
// with the header toggle).
const SideMenu = ({ icononly }) => {
    const expanded = icononly;

    return <aside className={expanded ? "smenu" : "smenu collapsed"}>
        <div className="smenuhead">
            <div className="smenulogo"><WarehouseOutlinedIcon fontSize="small" /></div>
            {expanded ? <span className="smenubrand">WMS</span> : <></>}
        </div>
        <nav className="smenucont">
            {visibleMenuGroups().map((g) => (
                <div className="smenugroup" key={g.label}>
                    {expanded ? <div className="smenugrouplabel">{g.label}</div> : <div className="smenugroupdivider" />}
                    {g.items.map((i) => (
                        <SideItem key={i.path} title={i.path} label={i.label} icons={i.icon} icononly={expanded} />
                    ))}
                </div>
            ))}
        </nav>
    </aside>
}

export default SideMenu;
